/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { clearAuthData } from "../../Allapis/Apikit/apikit";
import notifications from "../../assets/json/notifications";
import message from "../../assets/json/message";
// import gmoneImg from "../../assets/img/gmone_w.png";
import clayo_full_logo from "../../assets/img/clayo_full_logo.svg"

import { useLocation } from "react-router-dom/dist";

const Header = () => {
  const data = notifications.notifications;
  const datas = message.message;
  const [notification, setNotifications] = useState(false);
  const [flag, setflag] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [profile, setProfile] = useState(false);
  const [isProfileNameVisible, setProfileNameVisible] = useState(false);
  const profileId = localStorage.getItem("Id");
  const [seachValues, setSeachValues] = useState("");
  const navigate = useNavigate();

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };
  const onMenuClik = () => {
    document.body.classList.toggle("slide-nav");
  };

  const themes = localStorage.getItem("theme");

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setNotifications(false);
    setProfile(false);
    setflag(false);
  };

  const handleMouseOver = () => {
    setProfileNameVisible(true);
  };

  const handleMouseLeave = () => {
    setProfileNameVisible(false);
  };
  const handleFlags = () => {
    setflag(!flag);
    setIsOpen(false);
    setNotifications(false);
    setProfile(false);
  };

  const handleProfile = () => {
    setProfile(!profile);
    setNotifications(false);
    setflag(false);
    setIsOpen(false);
  };

  const location = useLocation();
  let pathname = location.pathname;
  // const { value } = useSelector((state) => state.user);
  const Email = localStorage.getItem("Name");
  const firstLetter = Email ? Email.charAt(0).toUpperCase() : "A";

  const logOut = () => {
    clearAuthData();
    window.location.replace("/");
  };

  return (
    <div className="header" style={{ right: "0px" }}>
      {/* Logo */}
      {/* <div className="header-left"></div> */}
      <Link
        id="toggle_btn"
        to="#"
        style={{
          display: pathname.includes("tasks")
            ? "none"
            : pathname.includes("compose")
            ? "none"
            : "",
          marginLeft: 10,
        }}
        onClick={handlesidebar}
      >
        <span className="bar-icon">
          <span />
          <span />
          <span />
        </span>
      </Link>
      {/* Header Title */}
      <div className="page-title-box">
        {/* <h3>GM ONE</h3> */}
        <img src={clayo_full_logo} alt="Clayo"/>
      </div>
      {/* /Header Title */}
      <Link
        id="mobile_btn"
        className="mobile_btn"
        to="#"
        onClick={() => onMenuClik()}
      >
        <i className="fa fa-bars" />
      </Link>
      {/* Header Menu */}
      <ul className="nav user-menu">
        <li className="nav-item dropdown has-arrow main-drop">
          <Link
            to="#"
            className="dropdown-toggle nav-link nav-link-brand"
            data-bs-toggle="dropdown"
            onClick={handleProfile}
            onMouseOver={handleMouseOver}
            onMouseLeave={handleMouseLeave}
          >
            {" "}
            <span
              className=" me-2   bg-blue"
              style={{
                borderRadius: "10px",
                padding: "8px 13px",
                fontSize: "12px",
                fontFamily: "poppins",
                fontWeight: "600"
              }}
            >
              {firstLetter ? `${firstLetter}` : ""}
            </span>
            <span className="status online" />
            {isProfileNameVisible && <span>{Email ? `${Email}` : ""}</span>}
          </Link>
          <div
            className={`dropdown-menu dropdown-menu-end ${
              profile ? "show" : ""
            }`}
          >
            <Link className="dropdown-item" to={`/profileInfo`}>
              My Profile
            </Link>
            <div className="dropdown-item" onClick={() => logOut()}>
              Logout
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Header;
